import React from 'react';
import {Link} from 'react-router-dom';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import Types from "constants/Types";

import {Button} from "reactstrap";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import ListItemText from "@material-ui/core/ListItemText";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import API from "@beardeddevops/react.api";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Dispositions',
		url: '/dispositions',
		icon: 'upload',
	},
	{
		name: 'Pending 4473s',
		url: '/dispositions/pendings',
		icon: 'ellipsis-h',
	},
];

export default class Pendings extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');
		this.state.customers = false;
		this.state.tab = 'details';

		this.state.anchorGen = null;
	}

	handleShowCustomers = () => {
		this.setState({customers: true});
		this.state.tab = 'duplicates';
	}

	handleOpen = (el) => event => {
		this.setState({
			[el]: event.currentTarget,
		});
	};

	handleClose = () => {
		this.setState({
			anchorGen: null,
		});
	};

	handleFormNumber = (form) => {
		this.setState({form});
	}

	printPdf = () => async () => {
		this.handleClose();
		let model = new API.BuildClass(Types.Dispositions_Pendings_Forms._name, API.RequestType.CREATE);

		//INFO: if pendings ever need to print another form, then we'll need to add a partial field or something
		model.object.form = this.state.form + 1; //the +1 is cause the partials are always 1 more than the form
		model.parent = this.props.id;

		try {
			await model.submit(null, API.RequestType.CREATE);
		} catch (e) {
			return;
		}

		this.setState({tab: 'forms'})

		this.refreshPage();
	};

	handleTab = () => {
		this.setState({tab: "details"});
	}


	render() {
		let {anchorGen, customers} = this.state;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: 'Page Two',
				url: `/dispositions/pendings/${this.props.id}`,
				icon: 'file-pdf-o',
			}
		]);

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					<Link to={`/dispositions/one_page/${this.props.id}`}>
						<Button style={{color: 'white'}} className="btn btn-sm blue-hoki">
							<i className="fa fa-arrow-left"/>&nbsp;&nbsp;Return to 4473 Review
						</Button>
					</Link>
					<Button
						size={"sm"}
						color="primary"
						aria-owns={anchorGen ? 'anchorGen' : null}
						aria-haspopup="true"
						onClick={this.handleOpen('anchorGen')}
					>
						<i className="fa fa-file-pdf-o"/>&nbsp;&nbsp;Generate Form
					</Button>
					<Menu
						id="anchorGen"
						anchorEl={anchorGen}
						open={Boolean(anchorGen)}
						onClose={this.handleClose}
						getContentAnchorEl={null}
						anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
						transformOrigin={{horizontal: 'left', vertical: 'top'}}
					>
						<MenuItem onClick={this.printPdf()}>
							<ListItemText inset primary="ATF 4473 (Partial Disposition Form)"/>
						</MenuItem>
					</Menu>
				</Framework.Components.PageBar>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Disposition" value="details"/>
					{customers && <Tab label="Existing Customer Match" value="duplicates"/>}
					<Tab label="Forms" value="forms"/>
				</Tabs>

				<div style={{display: this.state.tab === 'details' ? 'block' : 'none'}}>
					<Objects.DispositionPending
						id={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						kiosks={this.props.kiosks}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCustomers={this.handleShowCustomers}
						baseUrl={this.props.baseUrl}
						scannedCode={this.props.scannedCode}
						formNumber={this.handleFormNumber}
					/>
				</div>
				{(this.state.tab === 'duplicates' && customers) &&
				<Collections.CustomerDuplicates
					handleTab={this.handleTab}
					parent={this.props.match.params.id}
					type="pending"
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					handleTabChange={this.handleTabChange}
				/>}
				{this.state.tab === 'forms' &&
				<Collections.Forms
					parent={this.props.match.params.id}
					forForm={Types.Dispositions_Pendings_Forms._name}
					url="/dispositions/[PARENT]/pendings_forms"
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}
			</div>
		);
	}
}
